import { useRef } from 'react';
import { OrderInfo, CostBreakdown, FinancialSummary, CostItem } from '../types/budget';

export const useFileOperations = (
  orderInfo: OrderInfo,
  costBreakdown: CostBreakdown,
  financialSummary: FinancialSummary,
  setOrderInfo: (field: keyof OrderInfo, value: any) => void,
  setCostBreakdown: (category: keyof CostBreakdown, items: CostItem[]) => void
) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleImport = () => {
    fileInputRef.current?.click();
  };

  const handleFileImport = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const importedData = JSON.parse(e.target?.result as string);
          
          if (importedData.orderInfo) {
            // Update each field individually
            Object.entries(importedData.orderInfo).forEach(([key, value]) => {
              setOrderInfo(key as keyof OrderInfo, value);
            });
          }
          
          if (importedData.costBreakdown) {
            // Update each category individually
            Object.entries(importedData.costBreakdown).forEach(([key, value]) => {
              setCostBreakdown(key as keyof CostBreakdown, value as CostItem[]);
            });
          }
          
          alert('Data imported successfully!');
        } catch (error) {
          console.error('Error importing file:', error);
          alert('Error importing file. Please ensure it is a valid budget JSON file.');
        }
      };
      reader.readAsText(file);
    }
    
    // Reset file input
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const handleExport = () => {
    const data = {
      orderInfo,
      costBreakdown,
      financialSummary,
      exportDate: new Date().toISOString(),
    };
    console.log('Exporting budget data:', data);
    
    const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `budget-plan-${new Date().toISOString().split('T')[0]}.json`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return {
    fileInputRef,
    handleImport,
    handleFileImport,
    handleExport,
  };
};
